import { render, staticRenderFns } from "./InviteShopping.vue?vue&type=template&id=9af39f2c&"
import script from "./InviteShopping.vue?vue&type=script&lang=js&"
export * from "./InviteShopping.vue?vue&type=script&lang=js&"
import style0 from "./InviteShopping.vue?vue&type=style&index=0&id=9af39f2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports